'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect } from 'react';
import isClient from 'commons/isClient';
import categoryPageAlgoliaInstance from '../categoryPageAlgoliaInstance';

// useLayoutEffect warns during SSR; the sync below is a browser-only concern.
const useBrowserLayoutEffect = isClient() ? useLayoutEffect : useEffect;

/**
 * The category PLP shares one InstantSearch instance across routes (see
 * categoryPageAlgoliaInstance), and react-instantsearch only applies the
 * `indexName` prop when it changes between renders of an already-mounted
 * tree — a freshly keyed mount starts with prevProps === props, so the prop
 * is never (re)applied to the reused instance. Without this sync, the sort
 * index selected on the previous category keeps being searched on the next
 * one (and a ?sortBy= override in the target URL is ignored).
 */
const CategoryAlgoliaIndexSync = t0 => {
  const $ = _c(3);
  const {
    indexName
  } = t0;
  let t1;
  let t2;
  if ($[0] !== indexName) {
    t1 = () => {
      const helper = categoryPageAlgoliaInstance.current?.helper;
      if (!helper || !indexName || helper.state.index === indexName) {
        return;
      }
      helper.setIndex(indexName).setPage(0).search();
    };
    t2 = [indexName];
    $[0] = indexName;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useBrowserLayoutEffect(t1, t2);
  return null;
};
export default CategoryAlgoliaIndexSync;